export const USERS_LOAD_REQUEST = 'USERS_LOAD_REQUEST';
export const USERS_LOAD_SUCCESS = 'USERS_LOAD_SUCCESS';
export const USERS_LOAD_FAILURE = 'USERS_LOAD_FAILURE';
export const USERS_ADD_USER = 'USERS_ADD_USER';
export const USERS_UPDATE_USER = 'USERS_UPDATE_USER';
